import CustomStore from 'devextreme/data/custom_store'
import { axiosInstance } from '@/http-common'
import { AxiosResponse } from 'axios'
import jQuery from 'jquery'
import i18n from '@/i18n'

const $ = jQuery
const { t } = i18n.global || i18n

function getTypeText(type) {
    switch (type) {
        case 1:
            return t('components.tachographFiles.dataGrids.types.1')
        case 2:
            return t('components.tachographFiles.dataGrids.types.2')
        case 3:
            return t('components.tachographFiles.dataGrids.types.3')
        case 4:
            return t('components.tachographFiles.dataGrids.types.3')
        case 9:
            return t('components.tachographFiles.dataGrids.types.9')
        case 33:
            return t('components.tachographFiles.dataGrids.types.33')
        case 41:
            return t('components.tachographFiles.dataGrids.types.41')
    }
}

function getStatusText(status) {
    switch (status) {
        case 0:
            return t('components.tachographFiles.dataGrids.statuses.0')
        case 2:
            return t('components.tachographFiles.dataGrids.statuses.2')
        case 3:
            return t('components.tachographFiles.dataGrids.statuses.3')
        case 4:
            return t('components.tachographFiles.dataGrids.statuses.4')
        case 5:
            return t('components.tachographFiles.dataGrids.statuses.5')
        case 6:
            return t('components.tachographFiles.dataGrids.statuses.6')
        case 7:
            return t('components.tachographFiles.dataGrids.statuses.7')
        case 8:
            return t('components.tachographFiles.dataGrids.statuses.8')
        case 9:
            return t('components.tachographFiles.dataGrids.statuses.9')
        case 100:
            return t('components.tachographFiles.dataGrids.statuses.100')
        case 400:
            return t('components.tachographFiles.dataGrids.statuses.400')
        case 401:
            return t('components.tachographFiles.dataGrids.statuses.401')
        case 402:
            return t('components.tachographFiles.dataGrids.statuses.402')
        case 301:
            return t('components.tachographFiles.dataGrids.statuses.301')
        case 501:
            return t('components.tachographFiles.dataGrids.statuses.501')
        case 502:
            return t('components.tachographFiles.dataGrids.statuses.502')
        case 503:
            return t('components.tachographFiles.dataGrids.statuses.503')
    }
}

const store = new CustomStore({
    cacheRawData: false,
    key: 'id',
    load: () => {
        const d = $.Deferred()
        axiosInstance.get(`/api/v1/tacho/list`)
            .then((response: AxiosResponse) => {
                response.data.forEach(function (obj) {
                    obj.type = getTypeText(obj.type)
                    obj.status = getStatusText(obj.status)
                })
                d.resolve({ data: response.data, totalCount: null })
            })
            .catch(() => {
                d.resolve({ data: [], totalCount: null })
            })
        return d.promise()
    }
})

export function getStore(): CustomStore {
    return store
}